export default {"src":"/_next/static/media/search-icon2.5ea43ea8.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};